import './LegalPage.css';

/**
 * Shared shell for the standalone legal surfaces: a titled document header, an
 * optional sidebar, and a narrow reading column.
 */
export const LegalPage = ({ eyebrow, title, lede, meta, aside, children }) => (
  <article className="tl-legal">
    <div className="tl-shell tl-legal__header">
      {eyebrow && <p className="tl-eyebrow">{eyebrow}</p>}
      <h1 className="tl-legal__title">{title}</h1>
      {lede && <p className="tl-legal__lede">{lede}</p>}

      {meta && meta.length > 0 && (
        <dl className="tl-legal__meta">
          {meta.map((entry) => (
            <div key={entry.term}>
              <dt>{entry.term}</dt>
              <dd>{entry.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>

    <div className={`tl-shell tl-legal__body${aside ? '' : ' tl-legal__body--single'}`}>
      {aside}
      <div className="tl-legal__content">{children}</div>
    </div>
  </article>
);

/**
 * A numbered section with a stable `id`. The anchors are part of the page's
 * contract — Play Console reviews, support replies and the app itself link to
 * individual clauses, so they must not drift when the copy is edited.
 */
export const LegalSection = ({ id, title, children }) => (
  <section className="tl-legal__section" id={id} aria-labelledby={`${id}-title`}>
    <h2 id={`${id}-title`}>{title}</h2>
    {children}
  </section>
);

/** Sidebar index, built from the same list that renders the sections. */
export const LegalToc = ({ sections }) => (
  <nav className="tl-legal__toc" aria-label="On this page">
    <h2 className="tl-legal__toc-heading">On this page</h2>
    <ol>
      {sections.map((section) => (
        <li key={section.id}>
          <a href={`#${section.id}`}>{section.title}</a>
        </li>
      ))}
    </ol>
  </nav>
);
